import { useQuery } from "@tanstack/react-query";

export const useStandardQuery = ({
  queryFn = () => Promise.resolve({}),
  queryKey = ["standard"],
  initialData = {
    status: 0,
    response: {},
  },
  ...opts
}) => {
  return useQuery({
    queryKey: queryKey,
    queryFn,
    ...opts,
  });
};
